import type { UiTagType } from "@shared/components/UiTag/index.vue";
import { t } from "@shared/utils/i18n";

/** 用户状态：1 启用 2 禁用 */
export const SYSTEM_USER_STATUS_OPTIONS = [
    { label: t("启用"), value: 1 },
    { label: t("禁用"), value: 2 },
];

export function getUserStatusLabel(status: number): string {
    return SYSTEM_USER_STATUS_OPTIONS.find(item => item.value === status)?.label || "--";
}

export function getUserStatusTagType(status: number): UiTagType {
    return status === 1 ? "success" : "neutral";
}
